import { Link } from 'react-router-dom';

import type { EventProperties } from '@/lib/posthog/events';
import { useTrackEvent } from '@/lib/posthog/hooks/useTrackEvent';
import {
  Button,
  type ButtonProps,
} from '@/modules/ui/components/button/Button';

type UpgradeSource = EventProperties['upgradePlanClicked']['source'];

interface UpgradeButtonProps {
  /** Billing page link, including the tenant search when applicable. */
  to: string;
  /** Which gate the click came from, for the `upgradePlanClicked` event. */
  source: UpgradeSource;
  label?: string;
  size?: ButtonProps['size'];
  variant?: ButtonProps['variant'];
  className?: string;
}

/** The one upgrade action every paid-feature gate offers: a tracked link to Billing. */
export function UpgradeButton({
  to,
  source,
  label = 'Upgrade plan',
  size,
  variant,
  className,
}: UpgradeButtonProps) {
  const trackEvent = useTrackEvent();

  return (
    <Button asChild className={className} size={size} variant={variant}>
      <Link
        onClick={() => trackEvent('upgradePlanClicked', { source })}
        to={to}
      >
        {label}
      </Link>
    </Button>
  );
}
